// extracted by mini-css-extract-plugin
export default {"fotoSobreMim":"SobreMim_fotoSobreMim__WwVww","subtitulo":"SobreMim_subtitulo__fqboQ","paragrafo":"SobreMim_paragrafo__+KJ1m"};